import { runDemo } from "../shared/demoRunner";
import { createPbrScene } from "./scene";

runDemo({ createScene: createPbrScene });
